import * as XLSX from "xlsx";
import { MastersChangeLog } from "../../Utility";
import { Urls } from "../../../../Urls";
import { mailerAPI } from "../../../Freightrates1/Utility";
import { MASTER_URLS } from '../../../../Urls';
import { currentRequestTimeStamp } from '../../../../Constants';


export const containsSuspiciousContent = (fileData) => {
  const workbook = XLSX.read(fileData, { type: "array" });

  for (const sheetName of workbook.SheetNames) {
    const sheet = workbook.Sheets[sheetName];
    const parsedData = XLSX.utils.sheet_to_json(sheet);

    // Check for SQL injection patterns in the parsed data
    for (const row of parsedData) {
      for (const key in row) {
        const cellValue = row[key].toString();
        const sqlInjectionPatterns =
          /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

        if (sqlInjectionPatterns.test(cellValue)) {
          return true;
        }
      }
    }
  }

  return false;
};

export const downloadStandardFormat = (HEADERS, type, TrackMixPanel = () => { }) => {
  const ws = XLSX.utils.aoa_to_sheet([HEADERS]);

  if (type === "MaterialMaster") {
    const lengthColIndex = HEADERS.findIndex(h => h && h.toLowerCase().includes("length"));
    const breadthColIndex = HEADERS.findIndex(h => h && h.toLowerCase().includes("breadth"));
    const heightColIndex = HEADERS.findIndex(h => h && h.toLowerCase().includes("height"));
    const volumeColIndex = HEADERS.findIndex(h => h && h.toLowerCase().includes("volume"));

    const getColumnLetter = (colIndex) => {
      let letter = "";
      let temp = colIndex;
      while (temp >= 0) {
        letter = String.fromCharCode((temp % 26) + 65) + letter;
        temp = Math.floor(temp / 26) - 1;
      }
      return letter;
    };

    if (lengthColIndex !== -1 && breadthColIndex !== -1 && heightColIndex !== -1 && volumeColIndex !== -1) {
      const lenLetter = getColumnLetter(lengthColIndex);
      const breadLetter = getColumnLetter(breadthColIndex);
      const heightLetter = getColumnLetter(heightColIndex);
      const volLetter = getColumnLetter(volumeColIndex);

      const maxRows = 5000;
      for (let r = 2; r <= maxRows + 1; r++) {
        const cellAddress = `${volLetter}${r}`;
        ws[cellAddress] = {
          f: `IF(OR(${lenLetter}${r}="",${breadLetter}${r}="",${heightLetter}${r}=""),"",${lenLetter}${r}*${breadLetter}${r}*${heightLetter}${r})`
        };
      }

      // Add data validation to prevent manual entry in Volume column
      ws["!dataValidation"] = [
        {
          sqref: `${volLetter}2:${volLetter}${maxRows + 1}`,
          type: "custom",
          formula1: "FALSE",
          showErrorMessage: true,
          errorTitle: "Calculated Field",
          error: "Volume is automatically calculated from Length, Breadth, and Height columns. Manual entry is not allowed."
        }
      ];

      // Update ref to include all the populated rows
      const lastColLetter = getColumnLetter(HEADERS.length - 1);
      ws["!ref"] = `A1:${lastColLetter}${maxRows + 1}`;
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${type}.xlsx`);
  if (TrackMixPanel) {
    TrackMixPanel({
      ModuleName: "masters",
      ScreenName: `${type.toLowerCase()} master`,
      Data: "none",
      Definition: `user has downloaded standard format for ${type.toLowerCase()}`,
    })
  }
};

export const trackUserUploadsMastersFileForBulkUploads = (
  type,
  userDetails,
  company_id,
  fileName,
  TrackMixPanel = () => { }
) => {
  if (TrackMixPanel) {
    TrackMixPanel({
      ModuleName: "masters",
      ScreenName: "freight master",
      Data: fileName || "none",
      Definition: `user has uploaded ${type} master file`,
    })
  }

  MastersChangeLog(
    "New File Uploaded",
    `${type}_master`,
    userDetails.email,
    userDetails.user_id,
    company_id
  );
};

export const readExcelFile = async (file) => {
  try {
    const bufferArray = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });

    const wb = XLSX.read(bufferArray, { type: "buffer" });
    const ws = wb.Sheets[wb.SheetNames[0]];
    const data = XLSX.utils.sheet_to_json(ws);
    const headers = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];

    // Check for suspicious content
    if (containsSuspiciousContent(bufferArray)) {
      return {
        data: null,
        headers: null,
        error: "File contains suspicious content. Upload Aborted",
      };
    }

    return { data, headers, error: null };
  } catch (error) {
    return {
      data: null,
      headers: null,
      error: "An error occurred, aborting file upload.",
    };
  }
};

export const normalizedValue = (value) => {
  const normalized = value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, "");

  return normalized;
};

export const validRouteTypes = new Set(["pointtopoint", "multipoint"]);

export const isValidRouteType = (value) => {
  const normalized = normalizedValue(value);

  return validRouteTypes.has(normalized);
};

export const isValidSpotRoute = (value) => {
  const normalized = normalizedValue(value);

  return normalized === "yes" || normalized === "no";
};

export let isString = (value) => typeof value === "string";

export const checkSQL = (input) => {
  const regex = /\b(SELECT|INSERT|UPDATE|DELETE|DROP|CREATE|ALTER|TRUNCATE)\b/i;
  return regex.test(input);
};

// Image file reader function
export const readImageFile = async (file) => {
  try {
    const imageData = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });

    // Check if the file is an image
    if (!isValidImage(imageData)) {
      return {
        data: null,
        error: "Invalid image file. Upload aborted.",
      };
    }

    return { data: file, error: null };
  } catch (error) {
    return {
      data: null,
      error: "An error occurred, aborting file upload.",
    };
  }
};

// Function to check if the file is a valid image
export const isValidImage = (arrayBuffer) => {
  const arr = new Uint8Array(arrayBuffer).subarray(0, 4);
  let header = "";
  for (let i = 0; i < arr.length; i++) {
    header += arr[i].toString(16);
  }

  // Check the file signature
  switch (header) {
    case "89504e47":
      return true; // PNG
    case "47494638":
      return true; // GIF
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return true; // JPEG
    default:
      return false; // Not a known image type
  }
};

// PDF file reader function
export const readPDFFile = async (file) => {
  try {
    const pdfData = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });

    // Check if the file is actually a PDF
    if (!isValidPDF(pdfData)) {
      return {
        data: file,
        error: "Invalid PDF file. Upload aborted.",
      };
    }

    return { error: null };
  } catch (error) {
    return {
      error: "An error occurred, aborting file upload.",
    };
  }
};

// Function to check if the file is a valid PDF
export const isValidPDF = (arrayBuffer) => {
  const arr = new Uint8Array(arrayBuffer).subarray(0, 5);
  const header = String.fromCharCode.apply(null, arr);
  return header === "%PDF-";
};
/**
 * Validates and reads a file based on specified criteria. 
 * ALWAYS USE WITH AWAIT
 * @param {File} file - The file object to be validated and read.
 * @param {Array<string>} allowedTypes - Array of allowed file type categories ('image', 'pdf', 'excel').
 * @param {number} maxSizeInMB= - Maximum allowed file size in megabytes, pass 0 to skip this check
 * @returns {Promise<Object>} - A promise that resolves to the file data or an error object.
 */
export const validateAndReadFile = async (
  file,
  allowedTypes,
  maxSizeInMB = -1,
) => {

  // Define allowed MIME types
  const allowedMimeTypes = {
    image: ["image/jpeg", "image/png", "image/jpg", "image/bmp", "image/gif"],
    pdf: ["application/pdf"],
    excel: [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ],
  };

  // Convert MB to bytes
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

  // Check if file was selected
  if (!file) {
    return { error: "Please select a file to upload!" };
  }

  /**
   * Checks if the file type is allowed.
   * @param {File} file - The file to check.
   * @param {Array<string>} types - Array of allowed type categories.
   * @returns {boolean} - Whether the file type is allowed.
   */
  const isAllowedFileType = (file, types) => {
    const allowedMimes = types.flatMap((type) => allowedMimeTypes[type] || []);
    return allowedMimes.includes(file.type);
  };

  // Check if the file type is allowed
  if (!isAllowedFileType(file, allowedTypes)) {
    const formattedTypes =
      allowedTypes.length > 1
        ? `${allowedTypes.slice(0, -1).join(", ")} or ${allowedTypes.slice(-1)}`
        : allowedTypes[0];

    return { error: `Please upload a ${formattedTypes} file!` };
  }

  // Check file size
  if (!(maxSizeInBytes <= 0) && file.size > maxSizeInBytes) {
    return { error: `Please upload a file less than ${maxSizeInMB}MB!` };
  }

  // Read file based on its type
  try {
    let result;
    if (file.type.startsWith("image/")) {
      result = await readImageFile(file);
    } else if (file.type === "application/pdf") {
      result = await readPDFFile(file);
    } else if (allowedMimeTypes.excel.includes(file.type)) {
      result = await readExcelFile(file);
    } else {
      return { error: "Unsupported file type!" };
    }

    return result;
  } catch (error) {
    return { error: error.message };
  }
};

/**
 * Strips special characters from a string, allowing specified exceptions.
 * @param {string} input - The input string to process.
 * @param {string} exceptions - Optional. Characters to exclude from stripping.
 * @returns {string} - The processed string containing only alphanumeric characters, hyphens, and exceptions.
 */
export const stripSpecialChars = (input, exceptions = '') => {
  const regex = new RegExp(`[^a-zA-Z0-9-${exceptions}]`, 'g');
  return input.replace(regex, '');
};

/**
 * Strips non-numeric characters from a string.
 * @param {string} input - The input string to process.
 * @param {string} exceptions - Optional. Characters to exclude from stripping.
 * @returns {string} - The processed string containing only numeric characters and exceptions.
 */
export function stripNonNumeric(input, exceptions = '') {
  const regex = new RegExp(`[^0-9${exceptions}]`, 'g');
  return input.replace(regex, '');
}

/**
* Strips non-alphanumeric characters from a string.
* @param {string} input - The input string to process.
* @param {string} exceptions - Optional. Characters to exclude from stripping.
* @returns {string} - The processed string containing only alphanumeric characters and exceptions.
*/
export function stripNonAlpha(input, exceptions = '') {
  const regex = new RegExp(`[^a-zA-Z0-9${exceptions}]`, 'g');
  return input.replace(regex, '');
}

export const sendMailToMasters = async (masters_name, emailContent, toEmails, userAction, setshow = () => { }, userName) => {
  if (!toEmails?.length) return;

  toEmails?.length > 0 && toEmails?.map(async (i) => {
    const super_user_name = i?.name;
    const user_action = userAction?.action
    const editor_name = userName

    const masterUri = (masters_name) => {
      switch (true) {
        case masters_name === "Freight Master":
          return MASTER_URLS.FREIGHT;
        case masters_name === "Location Master":
          return MASTER_URLS.LOCATION;
        case masters_name === "Vendor Master":
          return MASTER_URLS.VENDOR;
        case masters_name === "Truck Master":
          return MASTER_URLS.TRUCK;
        case masters_name === "Material Master":
          return MASTER_URLS.MATERIAL;
        case masters_name === "Route Master":
          return MASTER_URLS.ROUTE;
        default:
          return MASTER_URLS.FREIGHT;
      }
    };

    // Variables to inject into template
    const getRenderedTable = (masters_name, action) => {
      switch (true) {
        case action === "New File Uploaded":
          return ``;
        case action === "Multiple Item(s) Deleted":
          return ``;

        // Freight Master
        case masters_name === "Freight Master" &&
          (action === "New Lane Added" ||
            action === "Lane Edited" ||
            action === "Lane Deleted"):
          return `
          <div style="overflow-x:auto;">
            <table border="1" style="border-collapse: collapse; width: 50%;">
              <tbody>
                <tr><th>Sr. No.</th><td>1</td></tr>
                <tr><th>Origin</th><td>${userAction?.lane?.origin?.location?.label || ''}</td></tr>
                <tr><th>Destination</th><td>${userAction?.lane?.destination?.location?.label || ''}</td></tr>
                <tr><th>Truck Type</th><td>${userAction?.lane?.truck_type?.value || ''}</td></tr>
                <tr><th>Transit Time</th><td>${userAction?.lane?.transit_time || ''}</td></tr>
              </tbody>
            </table>
          </div>
        `;

        // Location Master
        case masters_name === "Location Master" &&
          (action === "New Location Added" ||
            action === "Location Edited" ||
            action === "Location Deleted"):
          return `
          <div style="overflow-x:auto;">
            <table border="1" style="border-collapse: collapse; width: 50%;">
              <tbody>
                <tr><th>Sr. No.</th><td>1</td></tr>
                <tr><th>Location</th><td>${userAction?.lane?.location?.location?.label || userAction?.lane?.location?.location?.suggestion || userAction?.lane?.location?.location_name || ''}</td></tr>
                <tr><th>Address</th><td>${userAction?.lane?.addressLine1 || ''}</td></tr>
                <tr><th>Location Code</th><td>${userAction?.lane?.location_code || ''}</td></tr>
                <tr><th>Location Type</th><td>${userAction?.lane?.type || ''}</td></tr>
              </tbody>
            </table>
          </div>
        `;

        // Truck Master
        case masters_name === "Truck Master" &&
          (action === "New Truck Added" ||
            action === "Truck Edited" ||
            action === "Truck Deleted"):
          return `
          <div style="overflow-x:auto;">
            <table border="1" style="border-collapse: collapse; width: 50%;">
              <tbody>
                <tr><th>Sr. No.</th><td>1</td></tr>
                <tr><th>Truck Type</th><td>${userAction?.lane?.truck_type || ''}</td></tr>
                <tr><th>Truck Category</th><td>${userAction?.lane?.truck_category || ''}</td></tr>
                <tr><th>Truck Weight</th><td>${userAction?.lane?.weight || ''}</td></tr>
                <tr><th>Unit</th><td>${userAction?.lane?.unit || ''}</td></tr>
              </tbody>
            </table>
          </div>
        `;

        // Vendor Master
        case masters_name === "Vendor Master" &&
          (action === "New Vendor Added" ||
            action === "Vendor Edited" ||
            action === "Vendor Deleted"):
          return `
          <div style="overflow-x:auto;">
            <table border="1" style="border-collapse: collapse; width: 50%;">
              <tbody>
                <tr><th>Sr. No.</th><td>1</td></tr>
                <tr><th>Vendor Name</th><td>${userAction?.lane?.transporter_name || ''}</td></tr>
                <tr><th>Profile %</th><td>${userAction?.lane?.percentage_completion || ''}</td></tr>
                <tr><th>Vendor Code</th><td>${userAction?.lane?.vendor_code || ''}</td></tr>
                <tr><th>Groups</th><td>${userAction?.lane?.group?.length > 0 ? userAction?.lane?.group?.join(",") : ''}</td></tr>
              </tbody>
            </table>
          </div>
        `;

        // Vendor Group Edited
        case masters_name === "Vendor Master" && action === "Vendor Group Edited":
          return `
          <div style="overflow-x:auto;">
            <table border="1" style="border-collapse: collapse; width: 50%;">
              <tbody>
                <tr><th>Sr. No.</th><td>1</td></tr>
                <tr><th>Old Vendor Name</th><td>${userAction?.lane?.old_name || ''}</td></tr>
                <tr><th>New Vendor Name</th><td>${userAction?.lane?.new_name || ''}</td></tr>
              </tbody>
            </table>
          </div>
        `;

        // Vendor Group Deleted
        case masters_name === "Vendor Master" && action === "Vendor Group Deleted":
          return `
        <div style="overflow-x:auto;">
          <table border="1" style="border-collapse: collapse; width: 50%;">
            <tbody>
              <tr><th>Sr. No.</th><td>1</td></tr>
              <tr><th>Group Deleted</th><td>${userAction?.lane || ''}</td></tr>
            </tbody>
          </table>
        </div>
      `;

        // Material Master
        case masters_name === "Material Master" &&
          (action === "New Material Added" ||
            action === "Material Edited" ||
            action === "Material Deleted"):
          return `
        <div style="overflow-x:auto;">
          <table border="1" style="border-collapse: collapse; width: 50%;">
            <tbody>
              <tr><th>Sr. No.</th><td>1</td></tr>
              <tr><th>Material Description</th><td>${userAction?.lane?.material_description || ''}</td></tr>
              <tr><th>Material Category</th><td>${userAction?.lane?.material_category || ''}</td></tr>
              <tr><th>Volume</th><td>${userAction?.lane?.volume || ''}</td></tr>
              <tr><th>Material Code</th><td>${userAction?.lane?.material_code || ''}</td></tr>
            </tbody>
          </table>
        </div>
      `;

        // Route Master
        case masters_name === "Route Master" &&
          (action === "New Route Added" ||
            action === "Route Edited" ||
            action === "Route Deleted"):
          return `
        <div style="overflow-x:auto;">
          <table border="1" style="border-collapse: collapse; width: 50%;">
            <tbody>
              <tr><th>Sr. No.</th><td>1</td></tr>
              <tr><th>Origin</th><td>${userAction?.lane?.origin?.location?.label || userAction?.lane?.origin?.location?.suggestion || ''}</td></tr>
              <tr><th>Destination</th><td>${userAction?.lane?.destination?.location?.label || userAction?.lane?.destination?.location?.suggestion || ''}</td></tr>
              <tr><th>Route Type</th><td>${userAction?.lane?.route_code || ''}</td></tr>
              <tr><th>Distance</th><td>${userAction?.lane?.distance || ''}</td></tr>
            </tbody>
          </table>
        </div>
      `;

        default:
          return ``;
      }
    };



    const variables = {
      masters_name,
      masters_uri: masterUri(masters_name),
      super_user_name,
      user_action,
      UI_rendered_table_placeholder: getRenderedTable(masters_name, userAction?.action),
      masters_screen: masters_name,
      editor_name
    };

    // Simple replace function for {{ var }}
    const renderTemplate = (template, variables) => {
      return template?.replace(/{{\s*([^}]+)\s*}}/g, (_, key) => variables[key.trim()] ?? "");
    }

    const renderedContent = renderTemplate(emailContent?.content, variables);
    const renderedSubject = renderTemplate(emailContent?.subject, variables);

    // create email transproter body
    const emailTransporterBody = {
      activity: "Email Request",
      Application_name: "lorri",
      module_name: masters_name,
      timestamp: currentRequestTimeStamp(),
      to_email: i?.email,
      type: "superlaunch",
      mail_status: "Pending",
      from_email: emailContent?.from,
      user_type: "company",
      cc: ["connect@logisticsnow.in"],
      content: renderedContent,
      subject: renderedSubject,
    };

    try {
      // console.log(emailTransporterBody, "emailTransporterBody");
      await mailerAPI(emailTransporterBody, setshow);
    } catch (error) {
      console.log(error, "ERROR");
    }
  })
};

